import { BrowserRouter as Router } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import * as Sentry from '@sentry/react';

import { ClientContextController } from '@percent/hosted-validation-form/context/client/clientContextController/ClientContextController';
import { PartnerConfigContextController } from '@percent/hosted-validation-form/context/partnerConfig/PartnerConfigContextController/PartnerConfigContextController';
import { FormContextController } from '@percent/hosted-validation-form/context/form/FormContextController/FormContextController';
import { AnalyticsContextController } from '@percent/hosted-validation-form/context/analytics/AnalyticsContextController/AnalyticsContextController';
import { CaptchaContextController } from '@percent/hosted-validation-form/context/captcha/CaptchaContextController/CaptchaContextController';
import { i18n } from '@percent/hosted-validation-form/i18n/config';
import { logger } from '@percent/hosted-validation-form/utils/logger';

import { AppProvidersProps } from './AppProviders.types';
import { ErrorFallback } from './ErrorFallback';
import { PostHogProvider } from './PostHogProvider/PostHogProvider';
import { ThemeProvider } from './ThemeProvider/ThemeProvider';

export const AppProviders = ({ children }: AppProvidersProps) => (
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    <PostHogProvider>
      <I18nextProvider i18n={i18n}>
        <PartnerConfigContextController>
          <AnalyticsContextController
            logger={logger}
            writeKey={process.env.NX_PUBLIC_REACT_APP_SEGMENT_WRITE_KEY}
            options={{ disableClientPersistence: true }}
          >
            <FormContextController>
              <ThemeProvider>
                <Router>
                  <CaptchaContextController>
                    <ClientContextController>{children}</ClientContextController>
                  </CaptchaContextController>
                </Router>
              </ThemeProvider>
            </FormContextController>
          </AnalyticsContextController>
        </PartnerConfigContextController>
      </I18nextProvider>
    </PostHogProvider>
  </Sentry.ErrorBoundary>
);
